import { displayPartnerCustomerList } from '../../../../widgets/partner-customer-widget';
import { getSelectedItem } from './select-items';
import { searchAvailList } from './search-list';

import GetCustomers from '../../../../../routes/get-customers';

/**
 * Function that gets a list of customer data and displays it.
 * 
 * @retuns void
 */
const GetCustomerData = async () => { 
  const { body } = await GetCustomers();

  const mapList = Object.values(body).map((r: any) => ({
      id: r.customerId,
      name: r.customerName
  }));

  const customerList = document.querySelectorAll<HTMLElement>('[data-id]');
  const available = Array.from(customerList).map(e => ({
    customerId: e.getAttribute('data-id')
  }));

  const avalCustomers = mapList.filter(item => available.every(item2 => item2.customerId != item.id));
  const avaListContainer = document.querySelector('.aafp_list-result-container') as HTMLElement;
  const searchBar = document.querySelector('#aafp_customer-input') as HTMLInputElement;
  const con = document.querySelector('.aafp_customer-container') as HTMLElement;
  if (avaListContainer) {
    avaListContainer.innerText = '';
    displayPartnerCustomerList(avalCustomers, avaListContainer);
  
    getSelectedItem(avaListContainer, con);
    searchAvailList(searchBar, avaListContainer);
  }
}

export default GetCustomerData;